module.exports = __webpack_public_path__ + "img/stc_pay.926eaa48.svg";